export const cdnDomain: {[key: number]: string} = {
  100001: "https://cdn.connox.de",
  100009: "https://cdn.connox.at",
  100017: "https://cdn.connox.ch",
  100027: "https://cdn-fr.connox.ch",
  100005: "https://cdn.connox.com",
  100020: "https://cdn.connox.co.uk",
  100008: "https://cdn.connox.fr",
  100022: "https://cdn.connox.dk",
  100029: "https://cdn.connox.nl",
};
